import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43704389"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "details-form__item" }
const _hoisted_6 = { class: "details-form__item" }
const _hoisted_7 = { class: "details-form__item__title" }
const _hoisted_8 = { class: "profile-creation-wizard__content-indexable-row" }
const _hoisted_9 = { class: "form indexable-form" }
const _hoisted_10 = { class: "profile-creation-wizard__content-indexable-description" }
const _hoisted_11 = {
  class: "m-link",
  href: "#"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_seniority_level_selection = _resolveComponent("seniority-level-selection")!
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!
  const _component_step_actions = _resolveComponent("step-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "onClick:previous"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_seniority_level_selection, {
              class: "seniority-level-selection",
              "bottom-sheet-selector-prop": "#seniority-level-bottom-sheet",
              "data-heap-tooltip-id-prop": "profile-creation-tooltip-seniority-level",
              onSeniorityLevelSelected: _ctx.selectSeniorityLevel,
              onSeniorityLevelUnselected: _ctx.unselectSeniorityLevel
            }, null, 8, ["onSeniorityLevelSelected", "onSeniorityLevelUnselected"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.indexable.title')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_joy_checkbox, {
                  checked: _ctx.indexable,
                  name: "indexable",
                  value: _ctx.indexable,
                  onValueChange: _ctx.handleChangeIndexable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.indexable.checkbox')), 1)
                  ]),
                  _: 1
                }, 8, ["checked", "value", "onValueChange"])
              ]),
              _createVNode(_component_joy_highlight, {
                level: "info",
                "display-icon": ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.indexable.subtitle.short')) + " ", 1),
                    _createElementVNode("span", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowMoreIndexable && _ctx.toggleShowMoreIndexable(...args)))
                    }, [
                      _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.toggleShowMoreText), 1)
                    ]),
                    (_ctx.showMoreEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.indexable.subtitle.details')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "show-button-finish": true,
            "show-button-next": false,
            "show-button-skip": true,
            "is-disabled-button-finish": !_ctx.hasValidFieldPart,
            "is-hidden-button-skip": _ctx.hasValidFieldPart,
            "is-loading-button-finish": _ctx.isLoadingButtonFinish,
            "onClick:finish": _ctx.goNext,
            "onClick:skip": _ctx.goNext,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-finish", "is-hidden-button-skip", "is-loading-button-finish", "onClick:finish", "onClick:skip", "onClick:previous"])
        ])
      ])
    ])
  ]))
}